import script from "./AdminCreate.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminCreate.vue?vue&type=script&setup=true&lang=js"

import "./AdminCreate.vue?vue&type=style&index=0&id=d11bb796&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d11bb796"]])

export default __exports__